/**
 * usePrintV4 — 인페이지 인쇄 실행 (v4).
 *
 * v2의 window.open + document.write + 스타일시트 복사 + 고정 setTimeout을 전부 제거:
 *  1) @page 크기를 용지 실치수로 주입(@media print, B4는 JIS mm 명시)
 *  2) 포털(#pv4-portal) 외 모든 DOM을 인쇄에서 숨김 — 같은 문서라 스타일 복사 불필요
 *  3) document.fonts.ready + 이미지 decode를 기다린 뒤 window.print() — 레이스 없음
 * 사용자가 인쇄 대화상자에서 "PDF로 저장"을 고르면 그대로 벡터 PDF가 된다(서버 불필요).
 * 프린터 설정 안내: 여백=없음 · 배율=100% · 배경 그래픽 켬 (kyhub 실측 조건).
 */

export const PV4_PORTAL_ID = 'pv4-portal';

export async function printV4(geo) {
  const portal = document.getElementById(PV4_PORTAL_ID);
  if (!portal) return;

  const style = document.createElement('style');
  style.setAttribute('data-pv4-print', '');
  style.textContent = `
@media print {
  @page { size: ${geo.paper.w}mm ${geo.paper.h}mm; margin: 0; }
  html, body { background: #fff !important; margin: 0 !important; padding: 0 !important; height: auto !important; overflow: visible !important; }
  body > *:not(#${PV4_PORTAL_ID}) { display: none !important; }
  #${PV4_PORTAL_ID} { position: static !important; inset: auto !important; display: block !important; overflow: visible !important; height: auto !important; background: #fff !important; padding: 0 !important; z-index: auto !important; }
  /* .pv4-root = 모달 카드(95vw/960px·90vh·라운드·그림자) — 인쇄에서는 용지 실치수를 가리지 않도록 전부 해제 */
  #${PV4_PORTAL_ID} .pv4-root { position: static !important; inset: auto !important; display: block !important; width: auto !important; max-width: none !important; height: auto !important; max-height: none !important; margin: 0 !important; overflow: visible !important; background: #fff !important; border-radius: 0 !important; box-shadow: none !important; }
  #${PV4_PORTAL_ID} .pv4-no-print { display: none !important; }
  #${PV4_PORTAL_ID} .pv4-scroll { position: static !important; overflow: visible !important; height: auto !important; min-height: 0 !important; padding: 0 !important; background: #fff !important; }
  #${PV4_PORTAL_ID} .pv4-zoom { zoom: 1 !important; }
  #${PV4_PORTAL_ID} .pv4-page { margin: 0 !important; box-shadow: none !important; break-after: page; page-break-after: always; }
  #${PV4_PORTAL_ID} .pv4-page:last-child { break-after: auto; page-break-after: auto; }
}`;
  document.head.appendChild(style);

  // 스타일 제거 시점: afterprint 이벤트 기준 — window.print()가 비블로킹인 브라우저
  // (Safari 일부)에서 finally가 대화상자보다 먼저 실행돼 인쇄 CSS가 사라지는 것 방지.
  // 블로킹 브라우저는 print 반환 시점에 afterprint가 이미 발화(중복 remove는 무해).
  const cleanup = () => style.remove();
  window.addEventListener('afterprint', cleanup, { once: true });

  try {
    if (document.fonts?.ready) {
      await document.fonts.ready;
    }
    await Promise.all(
      Array.from(portal.querySelectorAll('img')).map((img) =>
        (img.decode ? img.decode() : Promise.resolve()).catch(() => {}),
      ),
    );
    window.print();
  } finally {
    setTimeout(cleanup, 60000); // afterprint 미발화 브라우저 대비 안전망
  }
}
